import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import InputContext from './InputContext'

const propTypes = {
    children: PropTypes.element.isRequired,
    callback: PropTypes.func,
}

const InputContextProvider = ({
    callback,
    children,
}) => {
    const value = useMemo(() => {
        return { callback }
    }, [callback])

    return (
        <InputContext.Provider
            value={value}
        >
            {children}
        </InputContext.Provider>
    )
}

InputContextProvider.propTypes = propTypes

export default InputContextProvider
